export default __webpack_public_path__ + "static/media/HumanAndPet.514b1f29.svg";